import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row no-gutters text-center" }
const _hoisted_3 = { class: "primary-links pb-2 mb-2 px-0" }
const _hoisted_4 = { class: "text-nowrap overflow-auto px-2 py-1" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "online-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.peopleList, (people) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "position-relative d-inline-block px-1",
              key: people.id
            }, [
              _createElementVNode("a", {
                href: `people/chat?id=${people._id.wpId}`,
                class: _normalizeClass(["btn ps-2 pe-3 d-flex align-items-center", people._id.active ? 'btn-primary text-light border-primary' : 'btn-light text-dark border-dark'])
              }, [
                _createElementVNode("div", {
                  class: "avatar avatar--mini flex-shrink-0 me-1",
                  style: _normalizeStyle({ backgroundImage: `url(${people._id.avatar})` })
                }, null, 4),
                (people.online)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(people._id.firstName) + " " + _toDisplayString(people._id.lastName) + " ", 1),
                (people._id.unreadMessage > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["badge mx-1", people._id.active ? 'bg-info' : 'bg-primary'])
                    }, _toDisplayString(people._id.unreadMessage), 3))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}